import React from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';

import { useInterval } from '@tzmedical/react-hooks';

import axios from '../../axiosClient.js';
import Alert from '../common/Alert.jsx';
import PageLoading from '../common/PageLoading.jsx';
import MonthlyNetSalesHeader from '../MonthlyNetSalesHeader.jsx';
import CommGrossMonthlyGrossSalesRow from './CommGrossMonthlyGrossSalesRow.jsx';

const REFRESH_INTERVAL_MS = 300_000;

function CommGrossMonthlyGrossSalesTable({ selectedYear, selectedRep }) {
  const [alertError, setAlertError] = React.useState(null);
  const [monthlyGrossSales, setMonthlyGrossSales] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const fetchMonthlyGrossSales = React.useCallback(async () => {
    try {
      const { data } = await axios.get(
        `/api/commgross/monthly-gross-sales/${encodeURIComponent(selectedRep)}/${selectedYear}`
      );
      setMonthlyGrossSales(data);
      setAlertError(null);
    } catch (err) {
      setAlertError(err.response?.data?.error || err.message);
    }
    setLoading(false);
  }, [selectedRep, selectedYear]);

  React.useEffect(() => {
    setLoading(true);
    setAlertError(null);
    setMonthlyGrossSales([]);
  }, [selectedRep, selectedYear]);

  useInterval(fetchMonthlyGrossSales, REFRESH_INTERVAL_MS, loading && !alertError);

  return (
    <Box>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>
        Monthly Gross Sales by Rep
      </Typography>
      <Alert message={alertError} setMessage={setAlertError} level="error" />
      {loading ? (
        <PageLoading />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <MonthlyNetSalesHeader />
            </TableHead>
            <TableBody>
              {monthlyGrossSales.map((grossSale) => (
                <CommGrossMonthlyGrossSalesRow grossSale={grossSale} key={grossSale.category} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default React.memo(CommGrossMonthlyGrossSalesTable);
